
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"39","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.048.5c-1.448 0-2.683.265-3.705.794a5.34 5.34 0 00-2.314 2.254c-.52.974-.78 2.125-.78 3.452s.26 2.477.78 3.45a5.333 5.333 0 002.314 2.255c1.021.528 2.256.793 3.705.793h5.178V.5h-5.178zm2.609 10.879h-2.571c-1.333 0-2.362-.374-3.086-1.123-.724-.748-1.086-1.834-1.085-3.256 0-1.424.362-2.51 1.085-3.258.724-.748 1.752-1.122 3.086-1.123h2.571v8.76zM8.885 1.294C7.862.764 6.627.5 5.178.5H0v13h2.571V2.617h2.571c1.333 0 2.362.375 3.086 1.123.724.75 1.085 1.836 1.085 3.26v6.5h2.667V7c0-1.326-.26-2.476-.781-3.45a5.336 5.336 0 00-2.314-2.256zM27.027 13.5h1.279c2.5 0 4.147-.415 5.34-1.336 1.124-.868 1.598-2.003 2.1-3.203V8.96l.045-.109L39 .5h-2.793L33.41 7.948l-.042.1c-.752 1.8-1.146 2.742-3.783 2.952V.5h-2.56v13z","fill":"#FEFEFE"}})])
          )
        }
      }
    